module.exports = `${require.publicPath}certificate-bg3.68d055c1.png`;